import ColorCubeIcon from "components/Icons/ColorCubeIcon";
import React, { Fragment } from "react";
import { packClasses } from "Utils";

function ToolbarButton(props) {
    const {
        icon,
        type,
        className,
        disabled,
        hidden,
        onClick,
        blocking,
        children,
        as,
        ...remainder
    } = props;

    if (as) {
        return React.createElement(as, {
            className: packClasses(
                "hover:bg-gray-100 hover:text-gray-900",
                "disabled:bg-white disabled:text-gray-800 disabled:opacity-50",
                "relative flex items-center rounded px-3 py-2 text-sm text-gray-800 lg:px-4",
                className ? className : ""
            ),
            onClick: onClick,
            disabled: disabled,
            hidden: hidden,
            children: (
                <Fragment>
                    {icon
                        ? React.cloneElement(icon, {
                              className: packClasses(
                                  "h-6 w-6 sm:h-5 sm:w-5 mr-1",
                                  blocking ? "opacity-0" : "opacity-1"
                              ),
                          })
                        : ""}
                    {children}
                </Fragment>
            ),
            ...remainder,
        });
    }
    return (
        <button
            type={type ? type : "button"}
            className={packClasses(
                "hover:bg-gray-100 hover:text-gray-900",
                "disabled:bg-white disabled:text-gray-800 disabled:opacity-50",
                "relative flex items-center rounded px-3 py-2 text-sm text-gray-800 lg:px-4",
                hidden ? "hidden" : "",
                className ? className : ""
            )}
            disabled={disabled}
            onClick={
                onClick
                    ? onClick
                    : () => {
                          return null;
                      }
            }
        >
            <ColorCubeIcon
                className={packClasses(
                    blocking ? " opacity-1" : " opacity-0",
                    "absolute inset-0 top-2 mx-auto h-5 w-5 animate-rotate-pulse"
                )}
                key="icn0"
            />
            {icon
                ? React.cloneElement(icon, {
                      className: packClasses(
                          "h-6 w-6 sm:h-5 sm:w-5 mr-1",
                          blocking ? "opacity-0" : "opacity-1"
                      ),
                  })
                : ""}
            <span
                className={packClasses(
                    "hidden md:flex",
                    blocking ? "opacity-0" : "opacity-1"
                )}
            >
                {children}
            </span>
        </button>
    );
}

export default ToolbarButton;
